"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/BannerAlertScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _BannerAlert = require('web/components/BannerAlert'); var _BannerAlert2 = _interopRequireDefault(_BannerAlert);

var _alertReducer = require('shared/reducers/alertReducer');


var _videoRoom = require('web/selectors/videoRoom');
var _user = require('shared/selectors/user');
var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _useSmsTrialEligibility = require('web/hooks/useSmsTrialEligibility');
var _hooks = require('web/services/hooks');















const cancelRequest = (org) => {
  _actions2.default.cancelJoinOrgRequest({ OrgKey: org.OrgKey })
    .then(() => _actions2.default.pushAlert("Success", `Your request to join ${org.Name} has been canceled.`, _alertReducer.AlertTypes.SUCCESS))
    .catch(() => _actions2.default.pushAlert('Error', 'Failed to cancel your join request', _alertReducer.AlertTypes.ERROR))
}

const startSmsTrial = (orgKey) => {
  _onboardingAnalytics.captureSmsTrialEntryClicked.call(void 0, { organization_id: orgKey, source: 'banner' })
  _actions2.default.gotoOnboardingPayment(orgKey)
}

// memo keeps connect()'s bailout on parent re-renders.
const BannerAlertScreen = _react.memo.call(void 0, function BannerAlertScreen () {
  // Server-authoritative SMS-trial eligibility (lazily fetched).
  const smsTrialOrgKey = _useSmsTrialEligibility.useSmsTrialEligibility.call(void 0, )
  const relationships = _hooks.useAppSelector.call(void 0, state => _user.selectCurrentUser.call(void 0, state).Relationships)
  const orgs = _hooks.useAppSelector.call(void 0, state => state.orgs)
  const call = _hooks.useAppSelector.call(void 0, state => state.call)
  // The selector builds a new array on every call; shallowEqual keeps the
  // previous one while its items are unchanged.
  const videoRoomPendingUsersList =
    _hooks.useAppSelector.call(void 0, _videoRoom.selectVideoRoomPendingUsersList, _reactredux.shallowEqual)
  const [serviceAlert, setServiceAlert] = _react.useState(null)

  const { userAlerts, relOrgs } = _react.useMemo.call(void 0, () => {
    const rels = (Object.keys(relationships) ).map(k => relationships[k])
    return {
      // inform the user their request is pending if in pending state
      userAlerts: rels
        .filter(r => r.Pending)
        .map(r => r.OrgKey)
        .map(k => orgs[k]),
      relOrgs: rels.map((r) => ({ org: orgs[r.OrgKey], rel: r })),
    }
  }, [relationships, orgs])

  _react.useEffect.call(void 0, () => {
    _client2.default.restFetchAlerts()
      .then(result => setServiceAlert(result))
      .catch(() => _client2.default.log({ message: 'Failed to load pending alerts' }))
      .catch(() => null)
  }, [])

  // infrom the user they just joined a new org
  const prevRelOrgsRef = _react.useRef.call(void 0, relOrgs)
  _react.useEffect.call(void 0, () => {
    const prevRelOrgs = prevRelOrgsRef.current
    prevRelOrgsRef.current = relOrgs
    if (prevRelOrgs === relOrgs) return

    const newOrg = prevRelOrgs
      .filter(ro => ro.rel.Pending)
      .find(relOrg => relOrgs.filter(ro => !ro.rel.Pending).find(ro => ro.org.OrgKey === relOrg.org.OrgKey))

    if (newOrg) {
      _actions2.default.pushAlert("Approved", `Your request to join ${newOrg.org.Name} has been accepted.`, _alertReducer.AlertTypes.SUCCESS)
    }
  }, [relOrgs])

  // Declined-SMS-cohort standing entry point into the onboarding trial offer.
  // Server-authoritative eligibility (the hook reads `TrialEligible`); ranked
  // above the other non-critical
  // alerts. Self-extinguishes once a trial starts (the flag flips server-side).
  // The whole banner is the click target (onClick), not just the button —
  // both routes run the same entry handler.
  const smsTrialAlertItems = smsTrialOrgKey ? [{
    message: 'Start your free 7-day SMS trial to text patients from a dedicated clinic number',
    onClick: () => startSmsTrial(smsTrialOrgKey),
    actions: [
      { text: 'Start trial', func: () => startSmsTrial(smsTrialOrgKey) },
    ],
  }] : []

  const pendingRequestItems = userAlerts.length > 0 ? userAlerts.map(org => ({
    message: `Your request to join ${org.Name} is pending`,
    actions: [
      { text: 'Cancel request', func: () => cancelRequest(org) },
    ],
  })) : []

  const callAlert = call.callMinimized && call.callOngoing ? [{
    message: `Call ongoing`,
    actions: [
      { text: 'Return to call', func: () => _actions2.default.returnToCall() },
      // { text: 'End call', func: () => actions.endCall()},
    ],
  }] : []

  const videoRoomAuthorizationAlert = videoRoomPendingUsersList.map(x => {
    const respond = (Approved) => _actions2.default.respondVideoRoomJoinRequest({
      Approved,
      RoomKey: x.RoomKey,
      RoomAuthorizationKey: x.RoomAuthorizationKey,
    })
    return {
      message: `${x.RoomAuthorizationUserName || 'Someone'} is requesting to join ${x.RoomName}`,
      actions: [
        { text: 'Approve', func: () => respond(true) },
        { text: 'Reject', func: () => respond(false) },
      ],
    }
  })

  const serviceAlertItems = serviceAlert != null ? [{
    message: serviceAlert,
    actions: [
      { text: 'Details', func: () => window.open('https://bloomtext.statuspage.io/') },
    ],
  }] : []

  // Critical (call/service) first, then video-room authorization — it
  // BLOCKS video functionality and only allAlerts[0] renders, so the
  // non-dismissible trial prompts must never starve it — then the
  // persistent prompts, then the informational pending-join notice.
  const allAlerts = [
    ...callAlert,
    ...serviceAlertItems,
    ...videoRoomAuthorizationAlert,
    ...smsTrialAlertItems,
    ...pendingRequestItems,
  ]

  const firstAlert = allAlerts[0]
  if (!firstAlert) {
    return null
  }

  return (
    _react2.default.createElement(_BannerAlert2.default, {
      ...firstAlert,
      breathing: callAlert.length > 0 && serviceAlertItems.length < 1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}
    )
  )
})

exports. default = BannerAlertScreen
